// @flow

import React from "react";
import styled from "styled-components";
import { Editor, EditorState } from "draft-js";

import { Flex, Text, Button } from "@src/common";
import spacingExtender from "@src/common/spacingExtender";
import { fullColorExtender } from "@src/common/colors";

import Checkbox from "material-ui/Checkbox";
import { Add } from "@src/common/muiComponents/checkbox";

// Mui Checkbox style
import { muiLabelStyle } from "@src/common/theme";

import RiskHeader from "./RiskHeader";

const Behaviour = styled(Flex)`
  flex: initial;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  ${() => spacingExtender({ paddingV: "2", paddingH: "4" })};
  border-bottom-style: solid;
  border-bottom-width: 1px;
  ${() => fullColorExtender({ borderColorB: "whiteGrey" })}

  &:last-child {
    border-bottom-style: none;
  }
`;

const BehaviourToggleRightLabel = styled(Text)`
  font-family: ${({ theme }) => theme.fonts.family.bookText};
  font-weight: ${({ theme }) => theme.fonts.weight.bookText};
  ${() => spacingExtender({ marginB: "1" })};
  margin-left: 6px;
`;

const Measure = styled(Flex)`
  cursor: pointer;
  flex: initial;
  justify-content: flex-start;
  align-items: flex-start;
  ${() => spacingExtender({ paddingV: "2", paddingH: "4" })};
  border-bottom-style: solid;
  border-bottom-width: 1px;
  ${() => fullColorExtender({ borderColorB: "whiteGrey" })}
`;

const Factor = styled(Flex)`
  cursor: pointer;
  flex: initial;
  justify-content: flex-start;
  align-items: flex-start;
  ${() => spacingExtender({ paddingV: "2", paddingH: "4" })};
  border-bottom-style: solid;
  border-bottom-width: 1px;
  ${() => fullColorExtender({ borderColorB: "whiteGrey" })}
`;

const Comment = styled(Flex)`
  ${() => spacingExtender({ paddingT: "4", paddingB: "4", paddingH: "4" })};
`;

const DraftComponentWrapper = styled(Flex)`
  font-family: ${({ theme }) => theme.fonts.family.bookText};
  font-weight: ${({ theme }) => theme.fonts.weight.bookText};
  font-size: ${({ theme }) => theme.fonts.sizes.Text5};
  ${() => spacingExtender({ paddingV: "2", paddingH: "4" })};
`;

class DraftComponent extends React.Component {
  state = {
    editorState: EditorState.createEmpty(),
    hasText: false,
    wasFocused: false
  };

  onChange = editorState => {
    this.setState({ editorState });
    if (typeof this.props.onChange === "function") {
      this.props.onChange(editorState);
    }
    if (editorState.getCurrentContent().getPlainText().trim()) {
      this.setState({ hasText: true });
    } else {
      this.setState({ hasText: false });
    }
  };

  clearEditor = () => {
    this.setState({
      editorState: EditorState.createEmpty(),
      hasText: false,
      wasFocused: false
    });
    this.editorRef.blur();
    if (typeof this.props.clearEditor === "function") {
      this.props.clearEditor();
    }
  };

  focusEditor = () => {
    this.editorRef.focus();
  };

  handleReturn = () => {
    const editorState = this.props.editorState || this.state.editorState;
    let value = editorState.getCurrentContent().getPlainText().trim();
    if (value) {
      this.editorRef.blur();
      this.setState(
        {
          editorState: EditorState.createEmpty(),
          hasText: false,
          wasFocused: false
        },
        () => {
          if (this.props.onEditorEnter) {
            this.props.onEditorEnter(value);
          }
        }
      );
    } else {
      this.clearEditor();
    }
    return true;
  };

  render() {
    const { editorPlaceHolder } = this.props;

    return (
      <DraftComponentWrapper justifyContent="flex-end" alignItems="top">
        <Checkbox
          checked={true}
          disableTouchRipple
          labelStyle={muiLabelStyle}
          iconStyle={{ marginRight: "10px" }}
          style={{ width: "initial" }}
          checkedIcon={<Add />}
          onClick={this.focusEditor}
        />
        {/*This div forces left-justify inside the flex*/}
        <div style={{ flex: 1, marginRight: "auto" }}>
          <Editor
            editorState={this.props.editorState || this.state.editorState}
            onChange={this.onChange}
            placeholder={editorPlaceHolder}
            handleReturn={() => true}
            ref={ref => {
              this.editorRef = ref;
            }}
            onFocus={() => this.setState({ wasFocused: true })}
          />
        </div>
        {!(this.state.hasText || this.state.wasFocused)
          ? null
          : <div>
              <Button secondary onClick={this.clearEditor} marginR={1} tiny>
                Cancel
              </Button>
              <Button primary onClick={this.handleReturn} tiny>
                Add
              </Button>
            </div>}
      </DraftComponentWrapper>
    );
  }
}

export {
  Behaviour,
  BehaviourToggleRightLabel,
  Comment,
  DraftComponent,
  Factor,
  RiskHeader,
  Measure
};



// WEBPACK FOOTER //
// ./src/containers/Assessment/components/index.js